import styled, { css, createGlobalStyle } from 'styled-components';

export const GlobalStyleForRootHeight = createGlobalStyle`
  #root {
    height: 100%;
  }
  &&body{
    height: 100%;
  }
  &&html {
    height: 100%;
  }
  body {
    overflow: hidden;
  }
`;

export const Wrapper = styled.div`
  width: 100%;
  position: relative;
  height: 100%;
`;

/** this exists in addition to Wrapper so that we can nest the modal portals appropriately in Wrapper without the padding
 * which e.g. messes up the DismissablePopover */
export const Content = styled.div`
  width: 100%;
  display: block;
  width: 100svw;
  position: relative;
  height: 100%;
  ${(props) =>
    props.$isFullscreen &&
    css`
      padding: 0;
    `}
`;

export const MainArea = styled.main`
  height: 100%;
  width: 100%;
  margin-right: -3rem;
  position: relative;
  background: #f3f3f3;
  user-select: none;
`;
export const Sidebar = styled.div`
  background: #fff;
  height: 100%;
  position: relative;
  border-left: var(--primary-border);
  border-radius: 20px;
  z-index: 3;
  transition: 1s all;
  ${(props) =>
    props.isFullscreen &&
    css`
      border-radius: 20px 0 0 20px;
    `}
`;
export const UnityWrapper = styled.div`
  position: relative;
`;

export const CornerUI = styled.div`
  position: absolute;
  top: 1rem;
  right: 4rem;
  z-index: 1;
  display: flex;
  gap: 0.5rem;
`;

export const Message = styled.div`
  padding: 2rem;
  display: flex;
  flex-direction: column;
  text-align: center;
  gap: 1rem;
  height: 100svh;
  justify-content: center;
  align-items: center;
`;
